import { memo } from 'react'
import { useSelector } from 'react-redux'
import { useResponsive } from 'hooks/useResponsive'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { IAIVideoProject } from 'types/aiVideo'
import { aiVideoSelectors } from 'store/features/aiVideo/selectors'
import { useAiVideoActions } from './hooks/useVideoActions'
import { useScrollableElement } from '../context'
import ActionsOverlay from 'common-components/ActionsOverlay'
import BaseVideoItem from '../components/VideoItem'
import { SQUARE_ASPECT_RATIO } from 'utils/aspectRatio'

const VideoItem: React.FC<IAIVideoProject> = (video: IAIVideoProject) => {
  const isMobile = useResponsive(SMALL_DESKTOP_SIZE_BREAKPOINT)
  const actionsData = useAiVideoActions({ video })
  const { scrollableElementRef } = useScrollableElement()
  const models = useSelector(aiVideoSelectors.aiVideoModels)
  const supportsAudio =
    models.find(model => model.model === video.videoModel)?.capabilities
      .isAudioGenerationSupported ?? false

  return (
    <BaseVideoItem
      videoUrl={video.videoUrl}
      status={video.status}
      assetId={video.id}
      aspectRatio={video.aspectRatio || SQUARE_ASPECT_RATIO}
      supportsAudio={supportsAudio}
      additionalContent={
        <ActionsOverlay
          actions={actionsData}
          contextMenuPosition={{
            flyoutOptions: {
              position: 'bottom',
              alignmentX: isMobile ? 'right' : 'left',
              extraOffset: 5
            }
          }}
          scrollableElementRef={scrollableElementRef}
        />
      }
    />
  )
}

export default memo(VideoItem)
